// extracted by mini-css-extract-plugin
export default {"sendTab":"A5NwM"};